import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-caption text-medium-emphasis d-flex align-center"
};
const _hoisted_2 = {
    key: 1,
    class: "text-caption text-error"
};
const _hoisted_3 = {
    key: 2,
    class: "text-caption text-medium-emphasis"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChartPrepareStatus',
    props: {
        preparing: { type: Boolean, default: false },
        error: { default: null },
        droppedPages: { default: () => [] },
        canChoosePages: { type: Boolean, default: false }
    },
    emits: ["choose-pages"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.preparing)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            size: "12",
                            width: "2",
                            class: "mr-2"
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode(" Preparing document… ", -1))
                    ]))
                    : (__props.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.error), 1))
                        : (__props.droppedPages.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.droppedPages.length) + " blank " + _toDisplayString(__props.droppedPages.length === 1 ? "page" : "pages") + " removed. ", 1))
                            : _createCommentVNode("", true),
                (__props.canChoosePages && !__props.preparing)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 3,
                        size: "small",
                        variant: "text",
                        color: "primary",
                        "prepend-icon": "mdi-file-document-multiple-outline",
                        class: "px-0 mt-1",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('choose-pages')))
                    }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" Choose pages ", -1)
                            ]))]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
